import { Box, Button, Flex, Modal, Stack, Text, Tooltip, Anchor } from "@mantine/core";
import {  IconCheck, IconPlus, IconX } from "@tabler/icons";
import  { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { openModal } from "@mantine/modals";
import { showNotification } from "@mantine/notifications";
import LogoIcon from "../../../../layouts/LogoIcon";
import { removeGtmIdeaId, assignRequestToNewIdea } from "../../../../../Api";
import AiCommentsMenu from "../Comment/AiCommentsMenu";
import { useParams } from "react-router-dom";
import useEvidenceActions from "../../../../../hooks/useEvidenceActions";
import { DeclineModal } from "../actions/DeclineModal";
import { RequestAssignment } from "../actions/RequestAssignment";
import AssignActionsMenu from "../actions/AssignActionsMenu";
import { useEvidenceDrawer } from "../../../../../hooks/useEvidenceDrawer";
import { useIdeaPage } from "../../../../../hooks/ideaPage";
import {useKnowledgeData} from "../../../../../hooks/useKnowledgeData";
import {useFields} from "../../../../../hooks/useFields";
import {useUserPermissions} from "../../../../../hooks/useUserPermissions";
import AssignToNewIdeaForm from "../../../../evidences/EvidenceModal/RightSide/AssignToNewIdeaForm";
const AiNewRequestActions = ({ 
  navToPerspective,
  componentId,
  chosenEvidence,
  validation,
  hoverCard,
  setShowHoverCard
}
: 
{ 
  navToPerspective: any,
  componentId: string,
  chosenEvidence: any,
  validation?: boolean;
  hoverCard?: boolean;
  setShowHoverCard?: (show: boolean) => void;
}) => {
  // FIX REASSIGN
  
  const { id: ideaId } = useParams<{ id: string }>();
  const { setChosenEvidence } = useEvidenceDrawer();
  const { 
    refetchEvidences, 
    idea,

  } = useIdeaPage();

  const { allComponents } = useFields();
  const { defaultStatus , defaultPriority } = useKnowledgeData();
  const auth0 = useAuth0();
  const { validate } = useEvidenceActions({ evidenceId: chosenEvidence._id });
  const { canManageEvidence } = useUserPermissions();
  const [opened, setOpened] = useState(false);
  const [newIdeaFormOpened, setNewIdeaFormOpened] = useState(false);
  const [loadingNew, setLoadingNew] = useState(false);

  const openDeclineModal = () => {
    setOpened && setOpened(false);
    openModal({
      modalId: "decline",
      title: <LogoIcon />,
      centered: true,
      size: 600,
      children: (
        <DeclineModal
          request={chosenEvidence}
          idea={idea}
          navToPerspective={navToPerspective}
          loadEvidence={refetchEvidences}
        />
      ),
    });
  };

  /* const handleDecline = () => {

    const rejectInfo = {reason: 'not relevant', comment:'not relevant'}

    dismissFeedback(item?._id,rejectInfo, auth0)
      .then((res) => {
        console.log(res)
      })
      .catch((e) => console.log(e))
  
  }; */

  const onValidate = () => {
    /* const requestObj = {...} */
    ideaId &&
    validate({ ideaId, sourceOfAssignment:"request" })
      .then((res) => {
        console.log({ res });
        if (res) {
          /* reCalculatPerspectiveForRequest(
            { ...res.evidence, state: "validated" },
            "add"
          ); */
        }
        refetchEvidences();
        showNotification({
          title: "Evidence added successfully",
          color: "teal",
          message: ``,
          icon: <IconCheck size="1.1rem" />,
        });
      })
      .then(() => setChosenEvidence(null))
      .catch((e) => console.log(e));
  };
  const item = chosenEvidence;

  const createNew = (values: any = {}) => {
    const resolvedComponentId = values?.componentId || componentId || item?.componentId || item?.ml?.mlComponentId;

    if (!resolvedComponentId) {
      showNotification({
        title: "Product Area Missing",
        color: "red",
        message: "Please assign a product area to this request before creating a new idea.",
        icon: <IconX size="1.1rem" />,
        autoClose: 1200,
      });
      return;
    }

    const foundComponent = allComponents.find((c: any) => c._id === resolvedComponentId);
    if (!foundComponent) {
      showNotification({
        title: "Invalid Product Area",
        color: "red",
        message: "Please assign a product area to this request before creating a new idea.",
        icon: <IconX size="1.1rem" />,
        autoClose: 1200,
      });
      return;
    }

    const title = values?.title || item?.title || item?.textItem?.title || "";
    const description = values?.description || item?.text || item?.textItem?.text || '';

    const newIdeaObj = {
      title,
      description,
      componentId: resolvedComponentId,
      ownerId: foundComponent.ownerId,
      rolloutDate: null,
      status: defaultStatus,
      priority: defaultPriority,
    };
    const evidence = { ...item, ownerId: foundComponent.ownerId, componentId: foundComponent._id };

    return assignRequestToNewIdea(
      { idea: newIdeaObj, evidence },
      auth0
    )
      .then((response) => {
        const ideaId = response.createNewIdeaRes?.idea?._id;
        showNotification({
          title: "Assigned successfully!",
          color: "teal",
          message: <Box>
            <Text>New idea has been created</Text>
            <Anchor href={`/idea/${ideaId}`} target="_blank">
                Go to the new idea
            </Anchor>
          </Box>,
          icon: <IconCheck size="1.1rem" />,
          autoClose: 1200
        });
        if (ideaId) {
          setTimeout(() => {
            window.open(`/idea/${ideaId}`);
          }, 1300);
        } else {
          console.log(`did not receive request id for new idea`, response);
        }
      })
      .catch((error) => {
        console.error("Error creating idea:", error);
        showNotification({
          title: "Error Creating Idea",
          color: "red",
          message:
              "An error occurred while creating the idea. Please try again.",
          icon: <IconX size="1.1rem" />,
          autoClose: 1200,
        });
        throw error;
      });
  };
  const moveToInbox = () => {
    if (!item?._id) {
      return
    }
  
    if (item?._id) {
  
      removeGtmIdeaId(
        item?._id,
        auth0
      )
        .then((response) => {
          showNotification({
            title: "Moved successfully!",
            color: "teal",
            message: "Moved Successfully",
            icon: <IconCheck size="1.1rem" />,
            autoClose: 1200
          });
        })
        .then(() => refetchEvidences())
        .catch(console.log)
          
    }
  };

  if (!canManageEvidence) {
    return (
      <Flex align="center" justify="center" p="sm">
        <Text color="dimmed" size="xs">
          View only - contact Admin or Manager to take action
        </Text>
      </Flex>
    );
  }
  return (
    <Flex
      justify={hoverCard ? "flex-start" : "space-between"}
      px={hoverCard ? 0 : "35px"}
      w={hoverCard ? "auto" : "100%"}
      pb={hoverCard ? "-10px" : "20px"}
      h={hoverCard ? "auto" : "64px"}
      sx={{ borderBottom: hoverCard ? "none" : "1px solid #D8D8DB" }}
      align="center"
    >
      {opened && (
        <Modal
          mt={100}
          opened={opened}
          onClose={() => setOpened(false)}
          size="32vw"
          title={
            <Text fz={20} fw={600}>
              Reassign to another idea
            </Text>
          }
          styles={{
            content: {
              marginLeft: "calc((100vw - 32vw) / 2) !important",
            },
          }}
        >
          <Stack h={445} pt={5} /* align="center" */ justify="center" w="100%">
            <Stack /* align="center" */ justify="center">
              <RequestAssignment
                idea={idea}
                item={chosenEvidence}
                setOpened={setOpened}
                navToPerspective={navToPerspective}
                TextInputW="100%"
              />
            </Stack>
          </Stack>
        </Modal>
      )}
      <Modal
        centered
        opened={newIdeaFormOpened}
        onClose={() => setNewIdeaFormOpened(false)}
        size="38vw"
      >
        <AssignToNewIdeaForm
          evidence={chosenEvidence}
          onCancel={() => setNewIdeaFormOpened(false)}
          onSubmit={(values) => {
            const promise = createNew(values);
            if (promise) {
              setLoadingNew(true);
              promise
                .then(() => {
                  setNewIdeaFormOpened(false);
                })
                .finally(() => {
                  setLoadingNew(false);
                })
                // Error already notified in createNew; absorb rejection to avoid unhandledrejection
                .catch(() => undefined);
            }
          }}
          loading={loadingNew}
        />
      </Modal>
      {!validation && !hoverCard && <AiCommentsMenu chosenEvidence={chosenEvidence}/>}
      <Flex align="center">
        <Button.Group>
          <Tooltip
            label="Assign to this Idea"
            multiline
            maw={200}
            offset={12}
            position="left"
          >
            <Button
              fz="12px"
              color="indigo"
              w="135px"
              styles={(theme) => ({
                root: {
                  height: "32px",
                  backgroundColor: "#5C5CEB",
                  color: "white",
                  border: 0,
                  fontWeight: 400,
                  padding: 0,
                  "&:hover": {
                    backgroundColor: theme.fn.darken("#5C5CEB", 0.05),
                  },
                },

                leftIcon: {
                  marginRight: 15,
                },
              })}
              onClick={() => {
                setShowHoverCard?.(false);
                onValidate();
              }}
            >
              <IconPlus size={14} />
              <Text>Assign to this Idea</Text>
            </Button>
          </Tooltip>
          <AssignActionsMenu
            actions={[
              {
                label: "Assign to another idea",
                tooltip: "Assign this request to a different idea",
                onClick: () => {
                  setShowHoverCard?.(false);
                  setOpened(true);
                }
              },
              {
                label: "Move to Inbox",
                tooltip: "Detach the Evidence from this Idea - it will show up in the Inbox for processing",
                onClick: () => {
                  setShowHoverCard?.(false);
                  moveToInbox();
                }
              },
              {
                label: "Assign to a new idea",
                tooltip: "Assign to a new idea",
                onClick: () => {
                  setShowHoverCard?.(false);
                  setNewIdeaFormOpened(true);
                }
              },
            ]}
          />
        </Button.Group>
      </Flex>
    </Flex>
  );
};

export default AiNewRequestActions;
